import { iconSize } from '@theme/globals/sizing';

const icon = {
  size: {
    ...iconSize,
  },
};
export default icon;
